import { render, staticRenderFns } from "./areaConfig.vue?vue&type=template&id=5d51ef4a&"
import script from "./areaConfig.vue?vue&type=script&lang=js&"
export * from "./areaConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d51ef4a')) {
      api.createRecord('5d51ef4a', component.options)
    } else {
      api.reload('5d51ef4a', component.options)
    }
    module.hot.accept("./areaConfig.vue?vue&type=template&id=5d51ef4a&", function () {
      api.rerender('5d51ef4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theater/areaConfig.vue"
export default component.exports